import { request } from "./api";

export type AdminHeroStats = {
  pendingReviews: number;
  newStudents7d: number;
  premiumRequests: number;
  errors24h: number;
};

export const adminHeroApi = {
  stats: (token: string) => request<AdminHeroStats>("/admin/hero-stats", {}, token),
};
